<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:5em; font:futura-bold;">“Our enemies are innovative and resourceful, and so are we. They never stop thinking about new ways to harm our country and our people, and neither do we.”</p>
<p style="text-align:center"><strong class="futura-bold"> —President George W. Bush </strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5443b1b0